import { useAccess } from "src/hooks/useAccess.hook";
import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import PersonOutline from "@iconify/icons-eva/person-outline";
import viewFill from "@iconify/icons-eva/eye-fill";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useMutate } from "src/hooks/useFetch.hook";
import { teamUrlId } from "src/react-query/endPoints";
import { useCallback, useMemo, useState } from "react";
import { dialogSlice } from "src/store/dailog/dailog.slice";
import { useDispatch, useSelector } from "react-redux";
import { FEATURE } from "src/util/enums";
import { authSlice } from "src/store/auth/auth.slice";
import MuiConfirmationDialog from "src/components/@material-extend/MuiConfirmationDialog";

export const TeamActionMenu = ({ id, row }) => {
  const dispatch = useDispatch();
  const isReadOnly = useAccess(FEATURE.TEAM, "R");
  const hasDeleteAccess = useAccess(FEATURE.TEAM, "D");
  const hasUpdateAccess = useAccess(FEATURE.TEAM, "U");
  const { mutate, isLoading } = useMutate("teams");
  const [confirmOpen, setConfirmOpen] = useState(false);

  const { user } = useSelector(({ auth }) => auth);
  const updateProfileRoles = useCallback(() => {
    const updatedRoles = user?.role.filter(
      (team) => Number(team.teamId) !== Number(id)
    );
    const updatedUser = { ...user, role: updatedRoles };
    dispatch(authSlice.actions.setUser(updatedUser));
  }, [id, dispatch, user]);

  const onDelete = useCallback(() => {
    mutate(
      { url: teamUrlId(id), method: "DELETE" },
      {
        onSuccess: () => {
          setConfirmOpen(false);
          updateProfileRoles();
        },
      }
    );
  }, [id, mutate, updateProfileRoles]);

  const manageUser = useCallback(() => {
    dispatch(dialogSlice.actions.setDialog({ open: true, id }));
  }, [dispatch, id]);

  const actionList = useMemo(
    () => [
      {
        id: "view",
        title: "View",
        icon: viewFill,
        routerLink: `/team/${id}`,
        hidden: !isReadOnly,
      },
      {
        id: "edit",
        title: "Edit",
        icon: editFill,
        routerLink: `/team/${id}`,
        hidden: !hasUpdateAccess,
      },
      {
        id: "delete",
        title: "Delete",
        icon: deleteFill,
        action: () => setConfirmOpen(true),
        hidden: !hasDeleteAccess,
      },
      {
        id: "manageUser",
        title: "Manage Users",
        icon: PersonOutline,
        action: manageUser,
      },
    ],
    [id, isReadOnly, hasDeleteAccess, hasUpdateAccess, manageUser]
  );

  return (
    <>
      <ActionsMenu menuList={actionList} />
      <MuiConfirmationDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        title="Delete Team"
        severity="error"
        contentText="This is an irreversible action. Once deleted, this team and all its associated data — including chargers, connectors, users, price groups, and configurations — will be permanently removed and cannot be recovered under any circumstances. Proceed only if you are absolutely certain."
        content={
          row?.name ? (
            <span>
              You are about to permanently delete team <strong>{row.name}</strong>.
            </span>
          ) : null
        }
        closeText="Cancel"
        okText="Yes, Permanently Delete"
        onOk={onDelete}
        isLoading={isLoading}
        maxWidth="sm"
      />
    </>
  );
};
